import useDriveStore from '@/stores/useDriveStore'
import MyDriveIcons from '@/icons/MyDriveIcons'
import ViewTypeSwitch from '../../ViewTypeSwitch'
import { Checkbox } from '@/components/ui/checkbox'
import { Button } from 'vnetwork-ui'
import DownLoadIcons from '@/icons/DownLoadIcons'
import { DownloadMultipleFilesParams, ObjectType } from '@/modules/Drive/types'

const Header = ({
    folderName,
    fullPath,
}: {
    folderName: string
    fullPath: string
}) => {
    const viewType = useDriveStore((state) => state.viewType)
    const setViewType = useDriveStore((state) => state.setViewType)
    const isSelectedAll = useDriveStore((state) => state.isSelectedAll)
    const downloadMultipleItems = useDriveStore(
        (state) => state.downloadMultipleItems
    )
    const isSelectedMode = useDriveStore((state) => state.isSelectedMode)
    const setIsSelectedAll = useDriveStore((state) => state.setIsSelectedAll)
    const setIsSelectedMode = useDriveStore((state) => state.setIsSelectedMode)
    const selectedItems = useDriveStore((state) => state.selectedItems)
    const clearSelectedItems = useDriveStore(
        (state) => state.clearSelectedItems
    )

    const handleDownload = async () => {
        if (selectedItems.length === 0 || !downloadMultipleItems) return

        const payload: DownloadMultipleFilesParams = {
            items: selectedItems.map((item) => ({
                object_type: item.endsWith('/')
                    ? ObjectType.FOLDER
                    : ObjectType.FILE,
                object_key: item,
            })),
            prefix: fullPath,
            zipName: `download-${Date.now()}.zip`,
        }

        setIsSelectedMode(false)
        setIsSelectedAll(false)
        clearSelectedItems()

        downloadMultipleItems(payload)
    }

    // const handleDelete = () => {
    //     console.log('Delete selected items:', selectedItems)
    // }

    // const handleMove = () => {
    //     console.log('Move selected items:', selectedItems)
    // }

    const SelectButtonGroup = () => {
        if (!isSelectedMode)
            return (
                <div className="flex gap-4 items-center">
                    <Button
                        color="primary"
                        onClick={() => {
                            setIsSelectedMode(true)
                        }}
                        startIcon={
                            <Checkbox
                                className="data-[state=checked]:border-white data-[state=checked]:text-white"
                                checked={true}
                            />
                        }
                    >
                        <p className="typo small text-white">Chọn</p>
                    </Button>
                </div>
            )
        return (
            <div className="flex gap-4 items-center">
                {selectedItems.length > 0 && actionGroup()}
                <p> đã chọn {selectedItems.length} mục</p>
                <Button
                    variant="outlined"
                    onClick={() => {
                        setIsSelectedAll(!isSelectedAll)
                    }}
                >
                    <p className="typo small">
                        {isSelectedAll ? 'Bỏ chọn tất cả' : 'Chọn tất cả'}
                    </p>
                </Button>
                <Button
                    color="error"
                    onClick={() => {
                        setIsSelectedMode(false)
                        setIsSelectedAll(false)
                        clearSelectedItems()
                    }}
                >
                    <p className="typo small">Hủy</p>
                </Button>
            </div>
        )
    }

    const actionGroup = () => {
        return (
            <div className="flex gap-4 items-center">
                <div
                    className="p-2 rounded hover:bg-gray-100 transition cursor-pointer"
                    title="Tải xuống"
                    onClick={handleDownload}
                >
                    <DownLoadIcons className="text-[#626262] size-5" />
                </div>
                {/* <div
                    className="p-2 rounded hover:bg-gray-100 transition"
                    title="Xóa"
                    onClick={handleDelete}
                >
                    <DeleteOutlineIcons className="text-[#626262] size-5" />
                </div>
                <div
                    className="p-2 rounded hover:bg-gray-100 transition"
                    title="Di chuyển"
                    onClick={handleMove}
                >
                    <MoveIcons className="text-[#626262] size-5" />
                </div> */}
            </div>
        )
    }

    return (
        <div className="flex justify-between">
            <div className="typo medium font-semibold text-primary text-base flex items-center gap-4">
                <span>
                    <MyDriveIcons className="w-5 h-5" />
                </span>
                {folderName}
            </div>
            <div className="flex gap-4 items-center">
                <SelectButtonGroup />
                <ViewTypeSwitch value={viewType} onChange={setViewType} />
            </div>
        </div>
    )
}

export default Header
